import { Indonesian } from 'flatpickr/dist/l10n/id'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import { today } from '@/store/helpers'

export const configFlatPickr = {
  mode: 'single',
  locale: Indonesian,
  altInput: true,
  altFormat: 'j/n/Y',
  dateFormat: 'Y-m-d',
  maxDate: today,
  disableMobile: true,
  plugins: [
    new MonthSelect({
      shorthand: true,
      dateFormat: 'Y-m-d',
      altFormat: 'M Y',
    }),
  ],
}

export const configPieChart = {
  chart: {
    type: 'donut',
  },
  legend: {
    show: true,
    position: 'bottom',
  },
  plotOptions: {
    pie: {
      donut: {
        size: '30%',
      },
    },
  },
}

export const fieldDetailOrder = [
  {
    key: 'no',
    label: 'No',
  },
  {
    key: 'name',
    label: 'Jenis Kendala',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
  {
    key: 'count',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
]
